// ── Branding ──────────────────────────────────────────────────────────────────
export const APP_NAME = 'Self-Fi'
export const APP_TAGLINE = 'Make every dollar work harder.'

// ── Thresholds ────────────────────────────────────────────────────────────────
export const DEFAULT_LARGE_TXN_THRESHOLD = 100

// ── Color Tokens ──────────────────────────────────────────────────────────────
export const COLOR_POSITIVE = '#2E7D32'
export const COLOR_NEGATIVE = '#C62828'
export const COLOR_NEUTRAL = '#94a3b8'

// ── Reward Categories ─────────────────────────────────────────────────────────
export const REWARD_CATEGORIES = [
  'dining',
  'groceries',
  'travel',
  'gas',
  'drugstore',
  'entertainment',
  'subscription',
  'streaming',
  'other',
] as const

export type RewardCategory = (typeof REWARD_CATEGORIES)[number]
